import { AssetTeamBase } from './base/asset-team-base';

export class AssetTeam extends AssetTeamBase { }